// extracted by mini-css-extract-plugin
module.exports = {"courses":"painting_courses__hZ7Hq","img1":"painting_img1__2mmll","img2":"painting_img2__2INgR","img3":"painting_img3__3MOlZ"};